<template>
  <div>
    <div
      v-for="(item, index) in resultData.data"
      :key="`search-result-item-${index}`"
      class="mb-3"
    >
      <callout ref="callout" :has-toggle="true">
        <div class="row">
          <div class="col-md-2 col-sm-12 border-right pr-3 pt-3">
            <span class="mt-4 bold">
              {{ item.requestNumber }}
            </span>
            <div>
              <span :class="getColorStatus(item.requestStatus)" />
              {{ item.requestStatus.name }}
            </div>
          </div>
          <div class="col-md-10 py-2 px-4">
            <div class="row">
              <div class="col-md-2 pl-md-4">
                <div class="data-label">
                  Municipio:
                </div>
                <span class="data">{{ item.municipality | empty }}</span>
              </div>
              <div class="col-md-2">
                <div class="data-label">
                  Escuela:
                </div>
                <span class="data">{{ item.school | empty }}</span>
              </div>
              <div class="col-md-2">
                <div class="data-label">
                  Tipo de Salón:
                </div>
                <span class="data">{{ item.classroomType }}</span>
              </div>
              <div class="col-md-2">
                <div class="data-label">
                  Fecha de Solicitud:
                </div>
                <span class="data">{{ item.requestDate | date }}</span>
              </div>
              <div class="col-md-2">
                <div class="data-label">
                  Nombre del Solicitante:
                </div>
                <span class="data">{{ item.applicantsName }}</span>
              </div>
              <div class="col-md-2 d-flex">
                <drop-down
                  class="align-self-center"
                  :data-item="{ item, index }"
                  :items="actionItems(item)"
                />
              </div>
            </div>
          </div>
        </div>
        <template #edition>
          <div class="bg-gray p-2">
            <div class="bg-white rounded p-3">
              <history :request-id="item.id" />
            </div>
          </div>
        </template>
      </callout>
    </div>
    <pagination
      v-if="showPagination"
      :data="resultData.pagination"
      :page-size="20"
      :show-text="true"
      @pagination-go-page="onPageChange"
    />
  </div>
</template>

<script>
import Callout from 'custom-callout';
import Pagination from 'pagination';
import DropDown from 'dropdown';
import History from './History';
import alert from '@/mixin/alert.mixin';
import {
  materialsEquipmentRequestStatus,
  materialsEquipmentRequestStatusString,
} from '@/utils/constants/pei/materials-equipment/MaterialsEquipmentRequestStatus';
import { changeRequestStatus } from '@/modules/materials-equipment/api.js';

export default {
  name: 'SearchResult',
  mixins: [alert],
  components: {
    Callout,
    Pagination,
    DropDown,
    History,
  },
  props: {
    resultData: {
      type: Object,
      default: () => ({
        data: [],
        pagination: {},
      }),
    },
  },
  data: () => ({
    selectedOption: null,
  }),
  computed: {
    showPagination() {
      return (
        this.resultData.data.length > 0 &&
        this.resultData.pagination.totalItemCount >
          this.resultData.pagination.perPage
      );
    },
    actionItems() {
      return (item) => {
        const actions = [];
        actions.push({
          label: 'Entrar',
          icon: 'fas fa-file-import color-primary-1',
          class: 'border-bottom',
          click: () => this.goToEdit(item.id),
        });
        switch (item.requestStatus.id) {
          case materialsEquipmentRequestStatus.Sometido:
          case materialsEquipmentRequestStatus.DevueltoEscuela:
          case materialsEquipmentRequestStatus.Aprobada:
          case materialsEquipmentRequestStatus.PendienteClasificacion:
            actions.push({
              label: 'Regresar Estatus Anterior',
              icon: 'fas fa-undo color-primary-1',
              click: () => this.revertStatus(item, item.previousStatusId),
            });
        }
        return actions;
      };
    },
  },
  methods: {
    getColorStatus(status) {
      let result = 'dot ';
      switch (status.id) {
        case materialsEquipmentRequestStatus.Sometido:
          result += 'sweetCorn';
          break;
        case materialsEquipmentRequestStatus.DevueltoEscuela:
        case materialsEquipmentRequestStatus.Aprobada:
        case materialsEquipmentRequestStatus.PendienteClasificacion:
          result += 'bg-secondary-38';
          break;
        default:
          result += 'gray-2';
          break;
      }
      return result;
    },
    getPreviousStatus(statusId) {
      switch (statusId) {
        case materialsEquipmentRequestStatus.Sometido:
          return materialsEquipmentRequestStatus.Nuevo;
        case materialsEquipmentRequestStatus.DevueltoEscuela:
        case materialsEquipmentRequestStatus.Aprobada:
        case materialsEquipmentRequestStatus.PendienteClasificacion:
          return materialsEquipmentRequestStatus.Sometido;
        default:
          return materialsEquipmentRequestStatus.Nuevo;
      }
    },
    onPageChange(page) {
      this.$emit('on-page-change', page);
    },
    openDetails(item, option) {
      if (
        (this.selectedOption !== option && !item.item.isOpen) ||
        this.selectedOption == option
      ) {
        this.toggleOpen(item.index);
      }
      this.selectedOption = option;
    },
    doSearch() {
      this.$emit('do-search');
    },
    async revertStatus(item, statusId) {
      await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea regresar al estatus anterior ${materialsEquipmentRequestStatusString[statusId]}?`
      ).then((res) => {
        if (res) {
          changeRequestStatus(item.id, { statusId })
            .then((res) => {
              if (res.status == 200) {
                this.ShowToast(
                  'Proceso exitoso.',
                  'Se regresó el estatus anterior exitosamente.',
                  'success'
                );
                this.doSearch();
              }
            })
            .catch((err) => {
              if (err && err.response && err.response.data) {
                this.ShowToast('Error', err.response.data.message, 'error');
              } else {
                this.ShowToast('Error', err.message, 'error');
              }
            });
        }
      });
    },
    goToEdit(id) {
      this.$router.push({
        name: 'materialAddRequest',
        params: {
          requestId: id,
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.balloon {
  padding: 6px;
  background: #fdfcf4 0% 0% no-repeat padding-box;
  border-radius: 20px;
  opacity: 1;
}
.dot {
  height: 15px;
  width: 15px;
  border-radius: 50%;
  display: inline-block;
}
.sweetCorn {
  background-color: #f8eb7f;
}
.bg-secondary-38 {
  background-color: #f8b184;
}
.bg-secondary-23 {
  background-color: #f8eb7f;
}
.bg-green-light {
  background-color: #a4e5b2;
}
.bg-brown {
  background-color: #d5b89a;
}
.gray-2 {
  background-color: #b5c3bc;
}
</style>
